var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { getTypographySize } from './utils';
import { ChipContainer, ChipContent, PrimaryLabel, SecondaryLabel } from './styled';
export const Chip = forwardRef((props, forwardedRef) => {
    const { icon, onClick, action, label, secondary, className, size = 'medium', variant = 'solid', appearance = 'primary', wrap = false } = props, rest = __rest(props, ["icon", "onClick", "action", "label", "secondary", "className", "size", "variant", "appearance", "wrap"]);
    const fontSize = getTypographySize(size);
    const containerProps = {
        onClick,
        as: onClick ? 'button' : 'div',
        type: onClick ? 'button' : undefined,
    };
    return (<ChipContainer $size={size} $variant={variant} $appearance={appearance} $wrap={wrap} className={className} ref={forwardedRef} {...rest}>
      <ChipContent {...containerProps}>
        {icon}
        {label && (<PrimaryLabel $fontSize={fontSize} $fontWeight="medium">
            {label}
          </PrimaryLabel>)}
        {secondary && (<SecondaryLabel $truncate $fontSize={fontSize} $appearance="100">
            {secondary}
          </SecondaryLabel>)}
      </ChipContent>

      {action}
    </ChipContainer>);
});
